const STEPS = [
  {
    n: "01",
    title: "Submit Loadout",
    body:
      "Fill in your target prestige, level, PSN ID and Discord tag. Order is instantly routed to Biipod's command channel.",
  },
  {
    n: "02",
    title: "Send Payment",
    body:
      "Pay via CashApp to $biipodmodding based on the package you picked ($50 / $75 / $120). Scan the QR or use the handle. Screenshot the receipt for record.",
  },
  {
    n: "03",
    title: "PS4 Testkit Deployment",
    body:
      "Your PSN account is loaded onto a PS4 Testkit. The unlock-all + level payload is injected server-side.",
  },
  {
    n: "04",
    title: "Delivery in ~5 Minutes",
    body:
      "Once Biipod picks up your order, the full unlock lands in ~5 minutes. During high-volume windows there may be a short queue before your order is picked up — you'll be updated on Discord.",
  },
];

export default function HowItWorks() {
  return (
    <div className="mx-auto max-w-7xl">
      <div className="mb-16 max-w-2xl">
        <div className="font-mono-hud text-xs uppercase tracking-[0.4em] text-[#ff6b00]">
          // Mission Brief
        </div>
        <h2 className="mt-3 font-display text-5xl uppercase tracking-tight text-zinc-100 sm:text-6xl">
          How the service <span className="text-[#ff6b00]">works</span>
        </h2>
        <p className="mt-4 font-hud text-lg text-zinc-400">
          A four-stage operation. Delivery takes ~5 minutes once your order is picked up
          — expect a short queue during high-traffic hours.
        </p>
      </div>

      <ol className="grid gap-px bg-zinc-900 md:grid-cols-2 lg:grid-cols-4" data-testid="how-it-works">
        {STEPS.map((s) => (
          <li
            key={s.n}
            className="group relative flex flex-col gap-4 bg-[#0a0a0a] p-8 transition-colors duration-150 hover:bg-[#0f0f0f]"
            data-testid={`step-${s.n}`}
          >
            <div className="flex items-center justify-between">
              <span className="font-display text-5xl leading-none text-[#ff6b00] bo2-text-glow">
                {s.n}
              </span>
              <span className="h-px w-16 bg-[#ff6b00]/40 transition-all duration-150 group-hover:w-24 group-hover:bg-[#ff6b00]" />
            </div>
            <h3 className="font-display text-2xl uppercase tracking-wide text-zinc-100">
              {s.title}
            </h3>
            <p className="font-hud text-sm leading-relaxed text-zinc-400">{s.body}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
